import { EventEmitter, Injectable } from '@angular/core';

import { AlbergoMaster, Lingua } from '../models/bo.model';
import { PaginaAlbergoMaster } from '../models/dto';
import { UtilityService } from './utility.service';

@Injectable({
  providedIn: 'root'
})
export class DmsService {

  public albergo: AlbergoMaster;
  public lingua: string;
  public selectedLanguage: Lingua = new Lingua();
  public pagineVisible: boolean = true;
  public pagine: PaginaAlbergoMaster[] = [];
  public pageClicked: EventEmitter<PaginaAlbergoMaster> = new EventEmitter();

  constructor(private utility: UtilityService) { }

  setLingua(lingua: string): Promise<void> {
    return this.utility.setLingua(lingua).then((l: Lingua) => {
      this.lingua = l?.codice;
      this.selectedLanguage = l;
    });
  }

  hidePagine() {
    setTimeout(() => {
      this.pagineVisible = false;
    }, 200);
  }

  showPagine() {
    setTimeout(() => {
      this.pagineVisible = true;
    }, 200);
  }
}